import * as React from 'react';
import { setCookie } from '@cian/utils/lib/browser/cookie';

const COOKIE_KEY = 'seen_cpd_landing';

export const useSetSeenLandingInCookie = () => {
  React.useEffect(() => {
    const currentDate = new Date();
    const dateThroughOneYear = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));

    setCookie(COOKIE_KEY, `1`, {
      expires: dateThroughOneYear,
      secure: false,
    });
  }, []);
};
